<script lang="ts">
	interface Props {
		className?: string;
	}

	let { className = '' }: Props = $props();
</script>

<div class={className}>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		stroke="currentColor"
		fill="none"
		stroke-width="1"
	>
		<line x1="3" y1="6" x2="21" y2="6" /><line x1="0" y1="12" x2="24" y2="12" /><line
			x1="3"
			y1="18"
			x2="21"
			y2="18"
		/>
	</svg>
</div>
